import {
  GetHearingQuantityListRes
  , WorkQuantity
} from '@gateway.Supplier'
import { yamadumiApi } from '../yamadumi-api'

export class PutSupplierHearingWorkQuantityListGateway {
  /** 業者ヒアリング(労務数)-明細登録 */
  static putHearingQuantityList = async (params: {data: GetHearingQuantityListRes }) => {
    const tempWorkQuantityList = params.data.workQuantityList.map(v => {
      // 工事名手入力
      let tempConstructionNmManual = v.constructionNmManual
      if (v.constructionNmManual === '' || v.constructionNmManual === undefined) {
        tempConstructionNmManual = null
      }
      // 受注元手入力
      let tempOtherCompany = v.otherCompany
      if (v.otherCompany === '' || v.otherCompany === undefined) {
        tempOtherCompany = null
      }
      // 施工部位コード
      let tempConstructionPartCd = v.constructionPartCd
      if (v.constructionPartCd === '' || v.constructionPartCd === undefined) {
        tempConstructionPartCd = null
      }
      // 工程状況コード
      let tempProcessStsCd = v.processStsCd
      if (v.processStsCd === '' || v.processStsCd === undefined) {
        tempProcessStsCd = null
      }
      // 遅延程度コード
      let tempDelayLevelCd = v.delayLevelCd
      if (v.delayLevelCd === '' || v.delayLevelCd === undefined) {
        tempDelayLevelCd = null
      }
      // 決定区分
      let tempDecisionKbn = v.decisionKbn
      if (v.decisionKbn === '' || v.decisionKbn === undefined) {
        tempDecisionKbn = null
      }
      // 備考
      let tempRemark = v.remark
      if (v.remark === '' || v.remark === undefined) {
        tempRemark = null
      }
      const tempObj: WorkQuantity = {
        ...v,
        constructionNmManual: tempConstructionNmManual,
        otherCompany: tempOtherCompany,
        constructionPartCd: tempConstructionPartCd,
        processStsCd: tempProcessStsCd,
        delayLevelCd: tempDelayLevelCd,
        decisionKbn: tempDecisionKbn,
        remark: tempRemark
      }

      return tempObj
    })
    const param = {
      data: {
        ...params.data,
        workQuantityList: tempWorkQuantityList
      }
    }
    return await yamadumiApi.put<GetHearingQuantityListRes>(
      '/api/supplier/hearing/work-quantity/list',
      param
    )
  }
}
